export function isEnvDisableCaptcha(env) {
    return env.DISABLE_CAPTCHA === "Y";
} 